/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { IntegrationServiceCombined, MapString, UserId } from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "integration-notifications";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Send notification to all users that have integration either NeverConnected, InTrouble or Disconnected
   *
   * @tags IntegrationNotifications
   * @name NotifyAllIntegrationNotConnectedV2
   * @request POST:/v2/tenant/{tenantId}/integration/{integration}/notifyIntegrationNotConnected
   * @secure
   */
  notifyAllIntegrationNotConnectedV2 = (
    tenantId: string,
    integration: IntegrationServiceCombined,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | UserId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/integration/${integration}/notifyIntegrationNotConnected`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for notifyAllIntegrationNotConnectedV2 */
  notifyAllIntegrationNotConnectedV2PathGetter = (tenantId: string, integration: IntegrationServiceCombined) =>
    this.getServicePath(`/v2/tenant/${tenantId}/integration/${integration}/notifyIntegrationNotConnected`);
}
